import { useState, useEffect } from "react";
import "./style.scss";

import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import InputTextUi from "@UI/InputTextUi";
import ButtonUi from "@UI/ButtonUi";

import { sendMetric, isStartScreenWidth } from "@utils";
import { useHandleResize } from "@hook";

import LikeImg from "./img/like.png";
import SearchImg from "./img/search.svg";
import CloseImg from "./img/times.svg";
import { getWhatId } from "@utils";

const { VITE_WHAT_ID } = import.meta.env;

const defaultRegion = {
    cities: [],
    name: "Москва",
    name_with_type: "г Москва",
    type: "г",
    _id: "664746e41feb2258b05f5e68",
};

const Default = inject("mainStore")(
    observer(({ mainStore }) => {
        const locationData = computed(() => mainStore.getMainStore("locationData")).get();
        const userLocation = computed(() => mainStore.getMainStore("userLocation")).get();
        const abTestMetika = computed(() => mainStore.getMainStore("abTestMetika")).get();
        const theme = mainStore.getMainStore("theme");
        const isMobile = useHandleResize();
        const localStorageUser = localStorage.getItem("locale_ris_promo")
            ? JSON.parse(localStorage.getItem("locale_ris_promo"))
            : userLocation && userLocation._gtip && userLocation._gtip.data && userLocation._gtip.data.region
              ? userLocation._gtip?.data?.region
              : defaultRegion;
        const region = locationData ? locationData : [];
        const regionLocation = region ? region.find((it) => it._id === userLocation.regionId) : null;

        const [city, setCity] = useState(localStorageUser.name_with_type);
        const [yourCityBtnYes, setYourCityBtnYes] = useState(false);
        const [yourCityBtnNo, setYourCityBtnNo] = useState(false);
        const [value, setValue] = useState({
            name: "",
            regionId: "",
            cityId: "",
            cities: [],
            city: "",
        });
        const [search, setSearch] = useState("");
        const [like, setLike] = useState(false);
        const [geo, setGeo] = useState(2);
        const [list, setList] = useState(true);
        const [isVizible, setIsVizible] = useState(false);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        useEffect(() => {
            if (regionLocation && !geo) {
                localStorage.setItem("locale_ris_promo", JSON.stringify(regionLocation));
            }
        }, [regionLocation, geo]);

        useEffect(() => {
            window.addEventListener("scroll", handleScroll);

            return () => window.removeEventListener("scroll", handleScroll);
        }, []);

        const tick = () => {
            if (like) {
                setLike((prev) => prev - 1);
            }
            if (geo) {
                setGeo((prev) => prev - 1);
            }
            if (isVizible && isVizible !== true) {
                setIsVizible((prev) => prev - 1);
            }
        };

        useEffect(() => {
            const time = setInterval(() => tick(), 1000);

            return () => clearInterval(time);
        });

        const handleScroll = (e) => {
            let elem = document.getElementById("city__block");
            let elem2 = document.getElementById("geolocation-city");
            let elem3 = document.getElementById("geolocation-city-white");

            if (isStartScreenWidth(767)) {
                if (elem) {
                    if (e.target.scrollingElement.scrollTop >= 65) {
                        elem.classList.add("white");
                    } else {
                        elem.classList.remove("white");
                    }
                }
                if (elem2) {
                    if (e.target.scrollingElement.scrollTop >= 65) {
                        elem2.style.display = "none";
                    } else {
                        elem2.style.display = "flex";
                    }
                }

                if (elem3) {
                    if (e.target.scrollingElement.scrollTop >= 65) {
                        elem3.style.display = "flex";
                        elem3.classList.add("white");
                        if (isVizible) {
                            setIsVizible(2);
                        }
                    } else {
                        elem3.classList.remove("white");
                        if (!isMobile) {
                            elem3.style.display = "none";
                        }
                    }
                }
            } else {
                if (elem) {
                    if (e.target.scrollingElement.scrollTop >= 180) {
                        elem.classList.add("white");
                    } else {
                        elem.classList.remove("white");
                    }
                }
                if (elem2) {
                    if (e.target.scrollingElement.scrollTop >= 180) {
                        elem2.style.display = "none";
                    } else {
                        elem2.style.display = "flex";
                    }
                }

                if (elem3) {
                    if (e.target.scrollingElement.scrollTop >= 180) {
                        elem3.style.display = "flex";
                        elem3.classList.add("white");
                        if (isVizible) {
                            setIsVizible(2);
                        }
                    } else {
                        elem3.classList.remove("white");
                        if (!isMobile) {
                            elem3.style.display = "none";
                        }
                    }
                }
            }
        };

        const handleClick = async () => {
            sendMetric(`click_confirm_change_location`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: null,
                params3: null,
                params4: null,
                params6: null,
                params7: null,
                params8: what_id,
            });

            let inData = {
                regionId: value.regionId,
                cityId: value.cityId ? value.cityId : "",
            };
            mainStore.setMainStore("listLoader", true);
            await mainStore.getByUrl("/app_rispromo_user/update_location", inData, false, "", false);
            await mainStore.getByUrl("/app_rispromo_user/user_locations", "", false, "userLocation", false);
            await mainStore.getByUrl("/app_rispromo/offers_list", "", false, "offersList", false);
            mainStore.setMainStore("listLoader", false);
            setIsVizible(1);
            setBodyStyle(false);
            setLike(1);
            setCity(value.city);
            setYourCityBtnYes(true);
            setValue({ ...value, cities: [] });
            setSearch("");
            localStorage.setItem("locale_ris_promo", JSON.stringify(value));
            setList(true);
        };

        const handleClickClose = () => {
            setCity(regionLocation.name_with_type);
            setBodyStyle(false);
            setYourCityBtnYes(true);
            setValue({ ...value, name: "", city: "", cities: [] });
            setSearch("");
            setList(true);
            setIsVizible(false);
        };

        const handleClickRegion = (item) => {
            setList(false);
            setValue({ city: item.name_with_type, regionId: item._id, cities: item.cities });
            setCity(item.name_with_type);

            if (item.cities.length) {
                setSearch("");
                setList(true);
            } else {
                setSearch(item.name_with_type);
            }
        };

        const handleClickCity = (item) => {
            setList(false);
            setValue({ ...value, cityId: item._id });
            setSearch(item.city);
        };

        const itemRegionSearche = region
            ? region.filter((item) => {
                  if (search) {
                      return item && item.name_with_type ? item.name_with_type.toLowerCase().includes(search.toLowerCase()) : "";
                  } else {
                      return region;
                  }
              })
            : [];

        const itemCitySearche = value.cities.filter((item) => {
            if (search) {
                return item && item.city ? item.city.toLowerCase().includes(search.toLowerCase()) : "";
            } else {
                return value.cities;
            }
        });

        const setBodyStyle = (yourCityBtnNo) => {
            setYourCityBtnNo(yourCityBtnNo);
            if (isMobile) {
                let body = document.body;
                if (body) {
                    if (yourCityBtnNo) {
                        body.style.overflow = "hidden";
                        body.style["touch-action"] = "none";
                        body.style["-webkit-overflow-scrolling"] = "none";
                        body.style["overscroll-behavior"] = "none";

                        body.style.width = "100%";
                    } else {
                        body.style = {};
                    }
                }
            }
        };

        const dizable = value.name === "" || value.city === "" || search === "" ? true : false;

        const cityHandler = () => {
            setBodyStyle(true);

            sendMetric(`click_change_location`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: null,
                params3: null,
                params4: null,
                params6: null,
                params7: null,
                params8: what_id,
            });
        };

        return (
            <div className={`geolocation ${like ? "like" : ""}`} style={yourCityBtnNo ? { height: "100%" } : {}} id="geolocation">
                <div className="geolocation-city" id="geolocation-city" onClick={cityHandler}>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.0002 19.4788C10.8654 19.4801 10.7337 19.4384 10.6243 19.3596C10.3493 19.1854 3.896 14.8496 3.896 9.57878C3.896 7.69463 4.64447 5.88766 5.97676 4.55537C7.30905 3.22308 9.11602 2.47461 11.0002 2.47461C12.8843 2.47461 14.6913 3.22308 16.0236 4.55537C17.3559 5.88766 18.1043 7.69463 18.1043 9.57878C18.1043 14.8496 11.6877 19.1854 11.376 19.3596C11.2666 19.4384 11.1349 19.4801 11.0002 19.4788ZM11.0002 3.89544C9.48713 3.89057 8.03401 4.48632 6.95984 5.55189C5.88568 6.61747 5.27827 8.06576 5.271 9.57878C5.271 13.4379 9.66183 16.9671 11.0002 17.9479C12.3385 16.9671 16.7293 13.4379 16.7293 9.57878C16.7221 8.06576 16.1146 6.61747 15.0405 5.55189C13.9663 4.48632 12.5132 3.89057 11.0002 3.89544Z"
                            fill={"#ACAEE9"}
                        />
                        <path
                            d="M11.0003 11.6872C10.5018 11.6872 10.0144 11.5393 9.59983 11.2623C9.18528 10.9853 8.86218 10.5916 8.67138 10.131C8.48058 9.6704 8.43066 9.16355 8.52793 8.67455C8.6252 8.18556 8.86528 7.73639 9.21783 7.38384C9.57037 7.0313 10.0195 6.79121 10.5085 6.69395C10.9975 6.59668 11.5044 6.6466 11.965 6.8374C12.4256 7.02819 12.8193 7.35129 13.0963 7.76584C13.3733 8.18039 13.5212 8.66777 13.5212 9.16634C13.5212 9.83491 13.2556 10.4761 12.7828 10.9488C12.3101 11.4216 11.6689 11.6872 11.0003 11.6872ZM11.0003 8.02051C10.7737 8.02051 10.5522 8.08771 10.3637 8.21362C10.1753 8.33952 10.0284 8.51848 9.94172 8.72785C9.85499 8.93722 9.8323 9.16761 9.87651 9.38988C9.92072 9.61215 10.0299 9.81632 10.1901 9.97657C10.3503 10.1368 10.5545 10.2459 10.7768 10.2902C10.9991 10.3344 11.2294 10.3117 11.4388 10.225C11.6482 10.1382 11.8271 9.99136 11.9531 9.80293C12.079 9.6145 12.1462 9.39297 12.1462 9.16634C12.1462 8.86245 12.0254 8.571 11.8106 8.35612C11.5957 8.14123 11.3042 8.02051 11.0003 8.02051Z"
                            fill={"#ACAEE9"}
                        />
                    </svg>
                    <span className={`geolocation-city__name`}>{city}</span>
                </div>

                <div
                    className="geolocation-city-white"
                    id="geolocation-city-white"
                    onClick={() => {
                        setBodyStyle(true);
                        setIsVizible(true);
                        sendMetric(`click_change_location`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: null,
                            params3: null,
                            params4: null,
                            params6: null,
                            params7: null,
                            params8: what_id,
                        });
                    }}
                    onMouseOver={yourCityBtnNo ? () => setIsVizible(true) : () => setIsVizible(2)}
                >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.0002 19.4788C10.8654 19.4801 10.7337 19.4384 10.6243 19.3596C10.3493 19.1854 3.896 14.8496 3.896 9.57878C3.896 7.69463 4.64447 5.88766 5.97676 4.55537C7.30905 3.22308 9.11602 2.47461 11.0002 2.47461C12.8843 2.47461 14.6913 3.22308 16.0236 4.55537C17.3559 5.88766 18.1043 7.69463 18.1043 9.57878C18.1043 14.8496 11.6877 19.1854 11.376 19.3596C11.2666 19.4384 11.1349 19.4801 11.0002 19.4788ZM11.0002 3.89544C9.48713 3.89057 8.03401 4.48632 6.95984 5.55189C5.88568 6.61747 5.27827 8.06576 5.271 9.57878C5.271 13.4379 9.66183 16.9671 11.0002 17.9479C12.3385 16.9671 16.7293 13.4379 16.7293 9.57878C16.7221 8.06576 16.1146 6.61747 15.0405 5.55189C13.9663 4.48632 12.5132 3.89057 11.0002 3.89544Z"
                            fill={"#1E22AA"}
                        />
                        <path
                            d="M11.0003 11.6872C10.5018 11.6872 10.0144 11.5393 9.59983 11.2623C9.18528 10.9853 8.86218 10.5916 8.67138 10.131C8.48058 9.6704 8.43066 9.16355 8.52793 8.67455C8.6252 8.18556 8.86528 7.73639 9.21783 7.38384C9.57037 7.0313 10.0195 6.79121 10.5085 6.69395C10.9975 6.59668 11.5044 6.6466 11.965 6.8374C12.4256 7.02819 12.8193 7.35129 13.0963 7.76584C13.3733 8.18039 13.5212 8.66777 13.5212 9.16634C13.5212 9.83491 13.2556 10.4761 12.7828 10.9488C12.3101 11.4216 11.6689 11.6872 11.0003 11.6872ZM11.0003 8.02051C10.7737 8.02051 10.5522 8.08771 10.3637 8.21362C10.1753 8.33952 10.0284 8.51848 9.94172 8.72785C9.85499 8.93722 9.8323 9.16761 9.87651 9.38988C9.92072 9.61215 10.0299 9.81632 10.1901 9.97657C10.3503 10.1368 10.5545 10.2459 10.7768 10.2902C10.9991 10.3344 11.2294 10.3117 11.4388 10.225C11.6482 10.1382 11.8271 9.99136 11.9531 9.80293C12.079 9.6145 12.1462 9.39297 12.1462 9.16634C12.1462 8.86245 12.0254 8.571 11.8106 8.35612C11.5957 8.14123 11.3042 8.02051 11.0003 8.02051Z"
                            fill={"#1E22AA"}
                        />
                    </svg>
                    {isVizible ? <span className={`geolocation-city__name`}>{city}</span> : isMobile ? <span className={`geolocation-city__name`}>{city}</span> : geo ? <span className={`geolocation-city__name`}>{city}</span> : null}
                </div>
                <div className={`geolocation-city__list ${yourCityBtnNo ? "" : "vizible"} ${!list ? "height" : ""}`}>
                    <div className="geolocation-city__list-title">
                        <span>{value.cities.length ? `Ваш город в ${city}` : "Выбор региона"}</span>
                        <img src={CloseImg} onClick={handleClickClose} />
                    </div>
                    <div className="geolocation-city__list-input">
                        <div className="geolocation-city__list-input__block">
                            <img src={SearchImg} />

                            <InputTextUi
                                value={search}
                                noAb={true}
                                className="input"
                                onChange={(e) => {
                                    setList(true);
                                    setSearch(e.target.value);
                                }}
                                placeholder={value.cities.length ? "Город..." : "Регион..."}
                            />
                        </div>
                    </div>

                    <div className={`geolocation-city__list-data ${!list ? "vizible" : ""} `}>
                        {itemCitySearche.length > 0 ? (
                            itemCitySearche.length ? (
                                itemCitySearche.map((it) => (
                                    <span className="cursor" key={it._id} onClick={value.cityId !== "" ? () => handleClickCity(it) : () => {}}>
                                        {it.city}
                                    </span>
                                ))
                            ) : (
                                <div className="search__text">По вашему запросу ничего не найдено</div>
                            )
                        ) : itemRegionSearche.length ? (
                            itemRegionSearche.map((it) => (
                                <span className="cursor" key={it._id} onClick={() => handleClickRegion(it)}>
                                    {it.name_with_type}
                                </span>
                            ))
                        ) : (
                            <div className="search__text">По вашему запросу ничего не найдено</div>
                        )}
                    </div>

                    <ButtonUi className={`geolocation-city__list-btn ${dizable ? "dizable" : ""}`} onClick={dizable ? () => {} : () => handleClick()} label="Выбрать" />
                </div>
                {like ? (
                    <div className="geolocation-city__like">
                        <img src={LikeImg} />
                        <span>Теперь будут отображаться купоны для вашего региона</span>
                    </div>
                ) : null}
            </div>
        );
    }),
);

export default Default;
